import styled from "styled-components";
import { BadgeProps } from "./types";
import { numeric } from "../../typography";
import "../../designTokens/variables.css";

type StyledBaseBadgeProps = {
  backgroundColor: string;
  color?: string;
  value: number | string;
};
const StyledBaseBadge = styled.div<StyledBaseBadgeProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0.25em 0.5em;
  height: 20px;
  min-width: 20px;
  width: ${(props) => (props.value.toString().length === 1 ? "20px" : "auto")};
  border-radius: var(--size-border-radius-large);
  background-color: ${(props) => props.backgroundColor};
  ${numeric.whiteActive.body3};
  ${(props) => props.color && `color: ${props.color}`};
  letter-spacing: normal;
`;

const StyledText = styled.span`
  position: relative;
  top: 0.05em;
`;

const StyledSmallBaseBadge = styled(StyledBaseBadge)`
  height: 16px;
  min-width: 16px;
  width: ${(props) => (props.value.toString().length === 1 ? "16px" : "auto")};
  ${numeric.whiteActive.caption};
  ${(props) => props.color && `color: ${props.color}`};
  letter-spacing: normal;
`;

type BaseBadgeProps = BadgeProps & StyledBaseBadgeProps;

export const BaseBadge = (props: BaseBadgeProps) => {
  return (
    <StyledBaseBadge {...props}>
      <StyledText>{props.value}</StyledText>
    </StyledBaseBadge>
  );
};

export const SmallBaseBadge = (props: BaseBadgeProps) => {
  return (
    <StyledSmallBaseBadge {...props}>
      <StyledText>{props.value}</StyledText>
    </StyledSmallBaseBadge>
  );
};
